<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" v-if="true">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="项目名称">
              <a-input v-model="queryParam.name" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="search" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="contract_info" slot-scope="text, record">
        {{ record.name + '（' + record.number + '）' }}
      </span>
      <span slot="unit_price_type" slot-scope="text, item">
        <span>
          {{ (text === 4 && item.price_type !== null) ? '关联点价': dictionaries.unit_price_type[text] || '无' }}
        </span>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleWatchView(record)">预览</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">计价</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <point-price-generate
      ref="createModal"
      :visible="visible"
      v-if="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <watch-point-price
      ref="watchModal"
      :visible="watchPointPriceVisible"
      v-if="watchPointPriceVisible"
      :loading="false"
      :contract="mdl"
      @cancel="watchPointPriceVisible=false"
      @ok="watchPointPriceVisible=false"
    />
    <edit-point-price
      ref="editModal"
      :visible="editPointPriceVisible"
      v-if="editPointPriceVisible"
      :loading="editPointPriceLoading"
      :contract="mdl"
      @cancel="handleEditCancel"
      @ok="handleEditOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import PointPriceGenerate from '../modules/FixedPriceGenerate'
import WatchPointPrice from '../modules/WatchPointPrice'
import EditPointPrice from '../modules/EditPointPrice'
import debounce from 'lodash/debounce'
import { user_list } from '@/api/user'
import {
  sell_contract_by_unit_price_type_list, sell_contract_fixed_price_details_create,
  sell_contract_valence_vertex_price_create, sell_contract_valence_vertex_price_delete
} from '@/api/trade_sell_contract'

export default {
  name: 'TableList',
  components: {
    STable,
    PointPriceGenerate,
    WatchPointPrice,
    EditPointPrice
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      watchPointPriceVisible: false,
      editPointPriceVisible: false,
      editPointPriceLoading: false,
      mdl: {},
      name: '',
      // 查询参数
      queryParam: {
        unit_price_type: 1
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '项目',
          width: 150,
          dataIndex: 'project'
        },
        {
          title: '合同类型',
          dataIndex: 'trade_type',
          width: 100,
          customRender: (text) => this.$Dictionaries.trade_sell_contract_type[text] || '无'
        },
        {
          title: '合同',
          dataIndex: 'number',
          width: 200,
          scopedSlots: { customRender: 'contract_info' }
        },
        {
          title: '定价方式',
          width: 150,
          dataIndex: 'unit_price_type',
          scopedSlots: { customRender: 'unit_price_type' }
        },
        {
          title: '创建时间',
          width: 150,
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return sell_contract_by_unit_price_type_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      clientList: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      this.mdl = { code: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDay() }
      this.visible = true
    },
    handleEdit (record) {
      // this.$router.push({ path: '/trade/purchase_sell_contract/point_price/' + record.id })
      this.mdl = record
      this.editPointPriceVisible = true
    },
    handleEditCancel () {
      this.editPointPriceVisible = false
      const form = this.$refs.editModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEditOk (data) {
      const form = this.$refs.editModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
          // 新增
          if (data !== undefined) {
            const commitData = this.handlePointPricingOK(data)
            this.editPointPriceLoading = true
            sell_contract_fixed_price_details_create(commitData).then(res => {
              if (res.code === 1000) {
                this.editPointPriceVisible = false
                form.resetFields()
              }
            }).finally(() => {
              this.editPointPriceLoading = false
            })
          }
        }
      })
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleDelete (record) {
      sell_contract_valence_vertex_price_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleWatchView (record) {
      this.mdl = record
      this.watchPointPriceVisible = true
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
            // 新增
          if (data !== undefined) {
            const commitData = this.handlePointPricingOK(data)
            this.confirmLoading = true
            sell_contract_valence_vertex_price_create(commitData).then(res => {
              if (res.code === 1000) {
                this.visible = false
                form.resetFields()
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    handlePointPricingOK (dataInfo) {
      const dataList = dataInfo['fixed_price_list']
      const postDataList = dataList.map(item => {
        const mapItem = { ...item }
        delete mapItem['editable']
        delete mapItem['key']
        return mapItem
      })
      const data = {
        fixed_price_list: postDataList,
        fixed_pricing_id: dataInfo['fixed_pricing_info'].price_type.id
      }
      return data
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleClientSearch (value) {
      user_list({ nickname: value }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    }
  }
}
</script>
